"use client"
import NextLink from "next/link"
import { useParams } from "next/navigation"

import { fallbackLocale } from "./settings"

export default function LocaleLink({
	href,
	children,
	...props
}: {
	href: string
	children: React.ReactNode
} & Omit<React.ComponentProps<typeof NextLink>, "href">) {
	const { locale } = useParams()

	// Ensure href and locale are valid strings before using them
	const safeHref = typeof href === "string" ? href : ""
	const safeLocale =
		typeof locale === "string" && locale.trim() !== "" ? locale : fallbackLocale

	// 清理可能的双斜杠
	const cleanHref = safeHref.replace(/\/+/g, "/")

	// 如果href已经包含locale，直接使用；否则添加locale前缀
	let finalHref: string
	if (
		cleanHref.startsWith(`/${safeLocale}/`) ||
		cleanHref === `/${safeLocale}`
	) {
		// href已经包含正确的locale，直接使用
		finalHref = cleanHref
	} else if (cleanHref.startsWith("/")) {
		// href是绝对路径但不包含locale，添加locale前缀6
		finalHref = `/${safeLocale}${cleanHref}`
	} else {
		// href是相对路径或其他格式，直接使用
		finalHref = cleanHref
	}

	return (
		<NextLink href={finalHref as any} {...props}>
			{children}
		</NextLink>
	)
}
